'use strict';

var icon = require('../../../../../../../../../../_virtual/icon.cjs');
require('../../base/accentColors.cjs');
var accentColors = require('../../../../../../../../../../_virtual/accentColors.cjs');

(function (exports) {

	var accentColors$1 = accentColors.__exports;

	exports.ICON_BASE_COLORS = void 0;
	(function(ICON_BASE_COLORS) {
	    ICON_BASE_COLORS["system"] = "system";
	    ICON_BASE_COLORS["primary"] = "primary";
	    ICON_BASE_COLORS["success"] = "success";
	    ICON_BASE_COLORS["info"] = "info";
	    ICON_BASE_COLORS["warning"] = "warning";
	    ICON_BASE_COLORS["danger"] = "danger";
	    ICON_BASE_COLORS["highlight"] = "highlight";
	})(exports.ICON_BASE_COLORS || (exports.ICON_BASE_COLORS = {}));
	const ICON_COLORS = {
	    ...exports.ICON_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	exports.ICON_COLORS = ICON_COLORS;
	
} (icon.__exports));
//# sourceMappingURL=icon.cjs.map
